import { render, staticRenderFns } from "./Dialog2.vue?vue&type=template&id=c37efca2&scoped=true&"
import script from "./Dialog2.vue?vue&type=script&lang=js&"
export * from "./Dialog2.vue?vue&type=script&lang=js&"
import style0 from "./Dialog2.vue?vue&type=style&index=0&id=c37efca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37efca2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
